import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Woodbury",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Woodbury Minnesota suburban cityscape with modern residential neighborhoods, green parks and golf courses, the St. Croix River valley in the distance, east metro skyline, warm golden hour lighting, clean professional photography, no readable text or signs",
  heroImageSeq: "woodbury-mn-hero",
  heroDescription:
    "Business trip to Europe in two weeks? Family vacation to Mexico and your passport just expired? Need a first-time passport for a new job requiring international travel? We help Woodbury residents — from east metro families to St. Paul corporate commuters — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  geoPosition: "44.9239; -92.9594",
  geoPlacename: "Woodbury, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/woodbury/",
  localAreaTitle: "Serving Woodbury & East Metro Washington County",
  localAreaText: [
    "Woodbury, Minnesota is one of the most dynamic and fastest-growing suburbs in the Twin Cities metro area. Located just east of St. Paul across the Mississippi River in Washington County, Woodbury has transformed from a bedroom community into a thriving city with its own corporate presence, retail centers, and medical facilities. The city's residents include downtown St. Paul commuters, 3M employees, healthcare professionals from the Woodbury Medical Center, and families drawn by the excellent schools and suburban quality of life.",
    "The corporate commuter pattern is strong. Woodbury residents work at companies with international operations throughout the Twin Cities — 3M in Maplewood, Ecolab in St. Paul, UnitedHealth Group in Minnetonka, and Target in Minneapolis. These professionals often receive international travel assignments with short notice: a client meeting in London, a product launch in Shanghai, a training session in Frankfurt. When a business trip is booked with two weeks notice and the traveler discovers their passport expired, standard government processing is not an option.",
    "Family travel is equally active. Woodbury's family-oriented community with excellent schools means spring break trips, summer European tours, and holiday cruises are common. The city's proximity to MSP Airport — about 20 minutes by car via I-494 — means families are often booked on international flights with relatively short lead times. When a child's passport expires or a teenager needs their first document for a school trip, the timeline is measured in days, not months. Fast Passport Center provides the expedited, professional service that Woodbury's active traveler community demands.",
  ],
  nearbyCities: [
    { name: "Woodbury", zips: "55125, 55129" },
    { name: "Oakdale", zips: "55115, 55128" },
    { name: "Lake Elmo", zips: "55042" },
    { name: "St. Paul", zips: "55101–55108, 55114, 55116, 55117, 55118, 55119, 55130, 55133, 55155" },
    { name: "Stillwater", zips: "55082, 55083" },
    { name: "Minneapolis", zips: "55401–55419" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your home or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Woodbury & East Metro Coverage",
  serviceAreaDescription: "Serving Washington County and east metro communities with overnight courier pickup",
  faqs: [
    {
      q: "How fast can I get a passport in Woodbury, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Woodbury can take 2–6 months. For business travelers and families with international plans, that timeline is not viable.",
    },
    {
      q: "Can business travelers from Woodbury expedite a passport quickly?",
      a: "Absolutely. Corporate travelers are one of our most common client types in Woodbury. International business trips often arrive with 2–3 weeks notice. We regularly process expedited renewals for professionals on compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "What if my passport expires before a family vacation?",
      a: "This is common, especially for families with children whose passports are only valid for 5 years. Many countries require six months validity. If your passport is close to expiring, we recommend expedited processing. Standard mail-in renewal typically takes 2–6 months.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Woodbury travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Woodbury. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the east metro.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "David R.",
      location: "Woodbury, MN",
      rating: 5,
      text: "I had a client meeting in London with eleven days notice. My passport had expired. Fast Passport Center processed my renewal in four business days. I made my flight and the meeting went perfectly. Their professional review caught a photo issue that would have delayed everything.",
      service: "Passport Renewal",
    },
    {
      name: "The Nguyen Family",
      location: "Woodbury, MN",
      rating: 5,
      text: "We planned a Caribbean cruise for our family of six and discovered two weeks before departure that our daughter's passport was expired. Fast Passport Center guided us through the child passport process, reviewed all our paperwork, and got her passport back in six business days. We made our cruise with time to spare.",
      service: "Child Passport",
    },
    {
      name: "Michelle T.",
      location: "Oakdale Area, Woodbury",
      rating: 5,
      text: "I was invited to a conference in Barcelona with three weeks notice. My passport had expired during COVID. Fast Passport Center had my renewal processed in five business days. I attended the conference and even extended my stay for a weekend. Exceptional service.",
      service: "Emergency Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "St. Paul", href: "/st-paul" },
    { name: "Rochester", href: "/rochester-mn" },
    { name: "Duluth", href: "/duluth-mn" },
    { name: "Oakdale", href: "/minnesota" },
    { name: "Stillwater", href: "/minnesota" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Woodbury",
  introDescription: "Fast, reliable passport processing for Woodbury and east metro Washington County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Woodbury and Twin Cities resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Woodbury Post Office",
      address: "7205 Guider Dr, Woodbury, MN 55125",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(651) 735-6664",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Woodbury and Washington County.",
    },
    {
      name: "Oakdale Post Office",
      address: "7039 10th St N, Oakdale, MN 55128",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 777-3939",
      notes: "Convenient for Oakdale and east metro residents. Passport photos available. Call ahead for appointment availability.",
    },
    {
      name: "St. Paul Main Post Office",
      address: "180 E Kellogg Blvd, St. Paul, MN 55101",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 224-1360",
      notes: "Serves St. Paul and east metro residents. Larger facility with more appointment slots.",
    },
    {
      name: "Stillwater Post Office",
      address: "219 N Main St, Stillwater, MN 55082",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 439-3160",
      notes: "Primary acceptance facility for Stillwater and eastern Washington County residents.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Woodbury", address: "10240 Hudson Rd, Woodbury, MN 55129", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Woodbury", address: "1020 Weir Dr, Woodbury, MN 55125", hours: "Call for hours" },
    { name: "The UPS Store — Woodbury", address: "1815 Weir Dr, Woodbury, MN 55125", hours: "Call for hours" },
    { name: "Walgreens — Oakdale", address: "6960 10th St N, Oakdale, MN 55128", hours: "Call for hours" },
    { name: "CVS Pharmacy — St. Paul", address: "1575 W University Ave, St. Paul, MN 55104", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — St. Paul", address: "55 E 5th St, St. Paul, MN 55101", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — Washington County",
      address: "Washington County area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Washington County Service Center — Stillwater",
      address: "Stillwater, MN 55082",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Stillwater option. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 15 miles from Woodbury — 20 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary commercial airport for the Twin Cities. Nonstop service to major international hubs including Amsterdam, London, Paris, Tokyo, and Reykjavik.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "Rochester, MN — about 70 miles south",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Secondary option for southern Minnesota travelers. Seasonal international charters and domestic connections.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "MSP — Minneapolis-Saint Paul International Airport",
      subtitle: "Primary gateway for Woodbury international travelers",
      content:
        "MSP is the primary departure point for Woodbury's international travelers. With nonstop service to Amsterdam, London, Paris, Tokyo, and Reykjavik, many residents connect directly to Europe and Asia. The airport's accessibility from the east metro via I-494 makes it a convenient hub for both corporate and leisure travel.",
      tip: "Check your passport expiration before booking MSP international connections. Most countries require six months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "Corporate & Business Travel",
      subtitle: "Woodbury professionals commuting to St. Paul and Minneapolis",
      content:
        "Woodbury residents work at companies with international operations throughout the Twin Cities. These professionals often receive travel assignments with 2–3 weeks notice: a client meeting in London, a product launch in Shanghai, a training session in Frankfurt. When a passport is discovered to be expired, standard processing is not fast enough.",
      tip: "Corporate travelers should check passport expiration at the start of each fiscal year. Set a calendar reminder six months before expiration.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Family & School Vacation Travel",
      subtitle: "Spring break, summer tours, and holiday cruises",
      content:
        "Woodbury families with children in the excellent school district plan spring break trips, summer European tours, and holiday cruises. Children's passports are valid for only 5 years. Many families discover expiration issues only after booking non-refundable travel.",
      tip: "Check every family member's passport at the start of the school year. Children's passports expire in 5 years, not 10.",
      icon: "ri-ship-line",
    },
    {
      title: "St. Croix River & Outdoor Recreation",
      subtitle: "Summer cabin travel and outdoor adventures",
      content:
        "Woodbury's proximity to the St. Croix River and outdoor recreation areas means many residents also maintain cabins and vacation properties in Canada and northern Minnesota. Summer travel to Canadian lakes and fishing destinations requires current passports for all travelers.",
      tip: "Canada travel requires passports for all family members. Even children need passports for international travel by air. Verify all documents before summer cabin season.",
      icon: "ri-tent-line",
    },
  ],
  destinations: [
    {
      name: "United Kingdom",
      context: "London business meetings, St. Paul corporate connections, and direct MSP flights",
      urgency: "Business travel frequently has 7–21 day lead time",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Frankfurt business, Munich trade shows, and 3M corporate connections",
      urgency: "Conference schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico & Caribbean",
      context: "Family cruises, Cancun resorts, and spring break trips from MSP",
      urgency: "Last-minute cruise deals and resort packages happen 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Japan",
      context: "Corporate travel, Ecolab connections, and Tokyo direct flights from MSP",
      urgency: "Asia business trips often have 10–21 day booking windows",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Toronto business, fishing trips to Ontario, and summer cabin visits",
      urgency: "Summer travel and hunting trips peak May through September",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Italy",
      context: "Medical conferences, Venice cruises, and European heritage tourism",
      urgency: "Conference schedules and cruise departures are fixed",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "60%",
      label: "of Woodbury expedited requests are business or family travel discovered within 3 weeks of departure",
    },
    {
      stat: "2–4 Weeks",
      label: "average notice Woodbury travelers have before a planned international trip",
    },
    {
      stat: "Mar–Aug",
      label: "peak season when spring break, summer vacations, and conference travel bookings collide",
    },
    {
      stat: "48 Hours",
      label: "shortest emergency turnaround we have accommodated for a Woodbury business traveler",
    },
  ],
};

export default function WoodburyPage() {
  return <CityPage data={data} />;
}